<template>
  <section>


    <!-- /////////////// WRAPPER -->
    <div>
      <!-- //TITLE MOBILE -->
      <h1 class="mobile">Parcourir</h1>
      <!-- //TITLE MOBILE -->

      <!-- //CONTENT -->
      <div class="content__browse">

        <!-- //TITLE DESKTOP -->
        <h1 class="desktop">Parcourir</h1>
        <!-- //TITLE DESKTOP -->

        <!-- SLIDER MOBILE -->
        <div class="block__slider cardSimple mobile">
          <VueSlickCarousel v-bind="settings">
            <div  class="wrapper">
              <b-card class="card-simple">
                <div class="number">
                  <PuSkeleton :loading="isLoading" :count="1">  
                      15
                  </PuSkeleton>                      
                </div>
                <div class="title">
                  <PuSkeleton :loading="isLoading" :count="2">  
                    Nouveau critère positif
                  </PuSkeleton>                      
                </div>
              </b-card>
            </div>

            <div  class="wrapper">
              <b-card class="card-simple text-yellow">
                  <div class="number">
                    <PuSkeleton :loading="isLoading" :count="1">  
                      10
                    </PuSkeleton>                          
                  </div>
                  <div class="title">
                    <PuSkeleton :loading="isLoading" :count="2">                    
                      Nouveau critère négatif
                    </PuSkeleton>                        
                  </div>
                </b-card>           
            </div>

            <div  class="wrapper">
              <b-card class="card-simple text-white">
                <div class="number">
                  <PuSkeleton :loading="isLoading" :count="1">  
                    65%
                  </PuSkeleton>                       
                </div>
                <div class="title">
                  <PuSkeleton :loading="isLoading" :count="2">                    
                    De taux positif
                  </PuSkeleton>                      
                </div>
              </b-card>
            </div>
          </VueSlickCarousel>
        </div>
        <!-- SLIDER MOBILE -->

        <!-- //CARD SIMPLE DESKTOP -->
        <b-row class="block__cardSimple">
          <b-col cols="4">
            <b-card class="card-simple">
              <div class="number">
                <PuSkeleton :loading="isLoading" :count="1">  
                  15
                </PuSkeleton>
              </div>
              <div class="title">
                <PuSkeleton :loading="isLoading" :count="2">  
                  Nouveau critère positif
                </PuSkeleton>
              </div>
            </b-card>
          </b-col>
          <b-col cols="4">
            <b-card class="card-simple text-yellow">
              <div class="number">
                <PuSkeleton :loading="isLoading" :count="1">  
                  10
                </PuSkeleton>                    
              </div>
              <div class="title">
                <PuSkeleton :loading="isLoading" :count="2">                    
                  Nouveau critère négatif
                </PuSkeleton>
              </div>
            </b-card>
          </b-col>
          <b-col cols="4">
            <b-card class="card-simple text-white">
              <div class="number">
                <PuSkeleton :loading="isLoading" :count="1">  
                  65%
                </PuSkeleton>                    
              </div>
              <div class="title">
                <PuSkeleton :loading="isLoading" :count="2">                    
                  De taux positif
                </PuSkeleton>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <!-- //CARD SIMPLE DESKTOP -->

        <!-- //SEP -->
        <div class="sep desktop"></div>
        <!-- //SEP -->

        <!-- //BT FAVORITE -->
        <b-button class="bt btn-favoris mt-4">
          <div class="left" slot="start">
            <span>
              <font-awesome-icon :icon="['fas', 'star']" />
            </span>
            <p class="title">Favoris</p>
          </div>
          <div class="right" slot="end">
            <p class='label'>Aucun</p>
            <span>
              <font-awesome-icon :icon="['fas', 'chevron-right']" />
            </span>            
          </div>
        </b-button>
        <!-- //BT FAVORITE -->

        <!-- //ILLUSTRATION -->
        <div class="illustration">
          <img :src="content.illustration.src" alt="illustration">
          <div class="title">{{content.illustration.title}}</div>
          <div class="desc">{{content.illustration.desc}}</div>
        </div> 
        <!-- //ILLUSTRATION -->
        
        
        <sidebar class="mobile" />
      </div>
      <!-- //CONTENT -->
    </div>
    <!-- /////////////// WRAPPER -->



    

    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
      <transition name="slide">      
        <keep-alive>
          <router-view class="transition"></router-view>
        </keep-alive>
      </transition> 
    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->

    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->
    <transition name="modal"> 
      <keep-alive>
        <router-view name="helper" class="myModal"></router-view>
      </keep-alive>
    </transition>    
    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->

  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import Sidebar from '../../../module/sidebar/Sidebar'
import ParentMixin from '../../ParentMixin'
import CatMixin from '../../category/CatMixin'

export default {
  name:"browseHome",
    components:{
      Sidebar,
    }, 
    mixins: [
      ParentMixin,
      CatMixin      
    ],
    computed: {
      ...mapGetters([
        'getBrowse',
        'getPageTransition',
      ])
    },
    data () {
      return {
        content:"",  
        isLoading:true,
      }
    },
    mounted(){
      this.scrollIt = this.getScroll;
    },
    created (){
      this.content = this.getBrowse;
      setTimeout(() => {
          this.isLoading = false;
          // this.majData();
        },2000)

    },   
    methods : { 
    },
   watch: {
    getPageTransition() {
      this.transition = this.getPageTransition;
      this.scrollIt = this.getScroll;
      console.log('this.transition == ' + this.transition)
    },
  }     
};
</script>
